const PageFlowDefine = () => import(/* webpackChunkName: "page-workflow" */ '@/modules/workflow/flowdefine/PageFlowDefine')
const PageFlowManager = () => import(/* webpackChunkName: "page-workflow" */ '@/modules/workflow/flowmanager/PageFlowManager')

const PageFlowOperatorDefine = () => import(/* webpackChunkName: "page-workflow" */ '@/modules/workflow/flowoperatordefine/PageFlowOperatorDefine')
const ModuleInterfaceConfig = () => import(/* webpackChunkName: "page-workflow" */ '@/modules/workflow/moduleinterfacedefine/ModuleInterfaceConfig')
const PageGeneralModule = () => import(/* webpackChunkName: "page-workflow" */ '@/modules/workflow/flowgeneralmodule/PageGeneralModule')
const PageBusinessForm = () => import(/* webpackChunkName: "page-workflow" */ '@/modules/workflow/flowbusinessform/PageBusinessForm')

export default [
  {
    path: '/ModuleInterfaceConfig',
    name: 'FLOWMODULE',
    component: ModuleInterfaceConfig,
    meta: {
      title: '模块接口配置',
    },
  },
  {
    path: '/PageFlowOperatorDefine',
    name: 'WORKYW',
    component: PageFlowOperatorDefine,
    meta: {
      title: '流程业务定义',
      isBlack: true
    },
  },

  {
    path: '/PageFlowDefine',
    name: 'WFDEFINE',
    component: PageFlowDefine,
    meta: {
      title: '流程定义',
      isBlack: true
    },
  },

  {
    path: '/PageFlowManager',
    name: 'FLOWMGR',
    component: PageFlowManager,
    meta: {
      title: '流程实例管理',
      isBlack: true
    },
  },

  {
    path: '/PageBusinessForm',
    name: 'FORMDEF',
    component: PageBusinessForm,
    meta: {
      title: '业务表单',
      isBlack: true
    },
  },

  {
    path: '/PageGeneralModule',
    name: 'GENERALMODULE',
    component: PageGeneralModule,
    meta: {
      title: '通用审批模块',
      isBlack: true
    },
  },
]
